import { castSetIsMuted } from "../castRequests/playerController";
import { store } from "global";

export function playerSetMute() {
    const isMuted = store.getState().player.muted;
    castSetIsMuted(isMuted);
}
